import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { getHttpErrorMessage } from '../http/http-error';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((err) => {
      const message = getHttpErrorMessage(err, 'HTTP error');
      console.error('[HTTP]', req.method, req.url, message);
      return throwError(() => err);
    })
  );
};
